import comp from "./StudentListSkeleton";
export default comp;
